<template>
  <div id="measurementData" class="animated fadeIn h-100">
    <div style="margin-bottom: 20px">
      <b-card class="h-100 m5 default-border1" body-class="h-100 p-0">
        <div class="searchBox flex-column">
          <div class="searchBoxRow">
            <label>프로젝트</label>
            <b-form-select
              class="w200"
              v-model="projectid"
              :options="projectOptions"
              required
            ></b-form-select>
            <label>구조물</label>
            <b-dropdown
              id="dropdown-form"
              :text="
                structure.isAllChecked
                  ? '전체'
                  : structure.selectedIdList.length > 0
                  ? structure.selectedTextList.join(',')
                  : '선택'
              "
              ref="dropdown"
              class="checkboxDropdown"
            >
              <b-dropdown-form class="checkboxDropdownForm">
                <b-form-input v-model="structure.input"></b-form-input>
                <div>
                  <div class="dropdownCheckbox">
                    <label>전체</label>
                    <b-form-checkbox
                      v-model="structure.isAllChecked"
                      @change="changeAllCheckBox(structure)"
                    >
                    </b-form-checkbox>
                  </div>
                </div>
                <div
                  v-for="(item, index) in structure.filteredOptions"
                  :key="index"
                >
                  <div class="dropdownCheckbox">
                    <label>{{ item.text }}</label>
                    <b-form-checkbox
                      v-model="item.isChecked"
                      @change="changeDropdownCheckBox(structure, index)"
                    >
                    </b-form-checkbox>
                  </div>
                </div>
              </b-dropdown-form>
            </b-dropdown>
            <label>디바이스</label>
            <b-dropdown
              id="dropdown-form"
              :text="
                device.isAllChecked
                  ? '전체'
                  : device.selectedIdList.length > 0
                  ? device.selectedTextList.join(',')
                  : '선택'
              "
              ref="dropdown"
              class="checkboxDropdown"
            >
              <b-dropdown-form class="checkboxDropdownForm">
                <b-form-input v-model="device.input"></b-form-input>
                <div>
                  <div class="dropdownCheckbox">
                    <label>전체</label>
                    <b-form-checkbox
                      v-model="device.isAllChecked"
                      @change="changeAllCheckBox(device)"
                    >
                    </b-form-checkbox>
                  </div>
                </div>
                <div
                  v-for="(item, index) in device.filteredOptions"
                  :key="index"
                >
                  <div class="dropdownCheckbox">
                    <label>{{ item.text }}</label>
                    <b-form-checkbox
                      v-model="item.isChecked"
                      @change="changeDropdownCheckBox(device, index)"
                    >
                    </b-form-checkbox>
                  </div>
                </div>
              </b-dropdown-form>
            </b-dropdown>
            <label>Sample Count</label>
            <b-form-input
              style="width: 100px"
              v-model="samplecnt"
              required
            ></b-form-input>
          </div>
          <div class="searchBoxRow">
            <label>센서 타입</label>
            <b-dropdown
              id="dropdown-form"
              :text="
                sensortype.isAllChecked
                  ? '전체'
                  : sensortype.selectedIdList.length > 0
                  ? sensortype.selectedTextList.join(',')
                  : '선택'
              "
              ref="dropdown"
              class="checkboxDropdown w160"
            >
              <b-dropdown-form class="checkboxDropdownForm">
                <div>
                  <div class="dropdownCheckbox">
                    <label>전체</label>
                    <b-form-checkbox
                      v-model="sensortype.isAllChecked"
                      @change="changeAllCheckBox(sensortype)"
                    >
                    </b-form-checkbox>
                  </div>
                </div>
                <div v-for="(item, index) in sensortype.options" :key="index">
                  <div class="dropdownCheckbox">
                    <label>{{ item.text }}</label>
                    <b-form-checkbox
                      v-model="item.isChecked"
                      @change="changeDropdownCheckBox(sensortype, index)"
                    >
                    </b-form-checkbox>
                  </div>
                </div>
              </b-dropdown-form>
            </b-dropdown>
            <label>데이터 타입</label>
            <b-dropdown
              id="dropdown-form"
              :text="
                datatype.isAllChecked
                  ? '전체'
                  : datatype.selectedIdList.length > 0
                  ? datatype.selectedTextList.join(',')
                  : '선택'
              "
              ref="dropdown"
              class="checkboxDropdown w160"
            >
              <b-dropdown-form class="checkboxDropdownForm">
                <!-- <div>
                  <div class="dropdownCheckbox">
                    <label>전체</label>
                    <b-form-checkbox
                      v-model="datatype.isAllChecked"
                      @change="changeAllCheckBox(datatype)"
                    >
                    </b-form-checkbox>
                  </div>
                </div> -->
                <div v-for="(item, index) in datatype.options" :key="index">
                  <div class="dropdownCheckbox">
                    <label>{{ item.text }}</label>
                    <b-form-checkbox
                      v-model="item.isChecked"
                      @change="changeDropdownCheckBox(datatype, index)"
                    >
                    </b-form-checkbox>
                  </div>
                </div>
              </b-dropdown-form>
            </b-dropdown>
            <label>기간</label>
            <b-form-select
              class="w100"
              v-model="periodtype"
              :options="periodtypeOptions"
              required
            ></b-form-select>
            <div v-if="periodtype == 'date'" class="d-flex">
              <b-form-input
                type="date"
                class="w170"
                v-model="stdate"
                required
              ></b-form-input>
              <label>~</label>
              <b-form-input
                type="date"
                class="w170"
                v-model="eddate"
                required
              ></b-form-input>
            </div>
          </div>
          <div class="searchBoxRow btnDiv">
            <b-button
              class="searchBtn"
              @click="getChartData"
              :disabled="
                structure.selectedIdList.length == 0 ||
                device.selectedIdList.length == 0
              "
              >조회</b-button
            >
            <b-button
              class="excelBtn"
              @click="downloadExcelFile"
              :disabled="chartData.length == 0"
            >
              <i class="fas fa-download" />Excel 다운로드
            </b-button>
          </div>
        </div>
      </b-card>
    </div>
    <div class="chartarea">
      <div id="Loader" v-if="LoadYn">
        <div class="spinner-bar">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <b-card
        id="measurementDataChart"
        class="h-100 m5 default-border1"
        body-class="h-100 p-0"
        header-tag="header"
        style="overflow-y: auto"
      >
        <b-row
          v-for="(item, idx) in chartData"
          :key="idx"
          :class="graphRowCnt === idx + 1 ? '' : 'pb20'"
        >
          <div
            v-if="!isGNSS(item.devicetype)"
            style="width: 100%; height: 100%; display: flex"
          >
            <b-col class="col-12">
              <b-card
                class="h-100 default-border1"
                body-class="h-100 p-0 ofh"
                header-tag="header"
              >
                <h6 slot="header">
                  {{ item.chartTitle }}
                </h6>
                <div
                  :id="
                    (isDynamicSensor(item.devicetype)
                      ? 'analChart'
                      : 'svChart') +
                    (idx + 1)
                  "
                  class="graph default-border-top1"
                ></div>
              </b-card>
            </b-col>
            <!-- <b-col class="col-6 pl10" v-show="!item.sensormodel.includes('HR')">
              <b-card
                class="h-100 default-border1"
                body-class="h-100 p-0 ofh"
                header-tag="header"
              >
                <h6 slot="header">
                  {{
                    item.sensoralias +
                    (isDynamicSensor(item.devicetype)
                      ? " 온도/습도"
                      : " 온도/습도/배터리")
                  }}
                </h6>
                <div
                  :id="'tempChart' + (idx + 1)"
                  class="graph default-border-top1"
                ></div>
              </b-card>
            </b-col> -->
          </div>
        </b-row>
      </b-card>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import utils from "../common/utils";
import chartUtil from "../common/chartUtil";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {},
  computed: {
    ...mapGetters([
      "getCenterBus",
      "getUserId",
      "getUserAuth",
      "getAlertOptions",
    ]),
  },
  data() {
    return {
      projectid: null,
      projectOptions: [],
      structure: {
        options: [],
        filteredOptions: [],
        input: null,
        selectedIdList: [],
        selectedTextList: [],
        isAllChecked: true,
      },
      device: {
        options: [],
        filteredOptions: [],
        input: null,
        selectedIdList: [],
        selectedTextList: [],
        isAllChecked: true,
      },
      sensortype: {
        codes: [],
        options: [],
        filteredOptions: [],
        input: null,
        selectedIdList: [],
        selectedTextList: [],
        isAllChecked: true,
      },
      datatype: {
        options: [
          { value: "anal1", text: "anal1", isChecked: true, group: "A" },
          { value: "anal2", text: "anal2", isChecked: true, group: "A" },
          { value: "sv", text: "s-v", isChecked: true, group: "A" },
          { value: "rawe", text: "rawe", isChecked: false, group: "B" },
        ],
        selectedIdList: ["anal1", "anal2", "sv"],
        selectedTextList: ["anal1", "anal2", "s-v"],
        isAllChecked: true,
      },
      stdate: null,
      eddate: null,
      periodtype: "date",
      periodtypeOptions: [
        { value: "date", text: "날짜" },
        { value: "1h", text: "1h" },
        { value: "1d", text: "1d" },
        { value: "7d", text: "7d" },
        { value: "30d", text: "30d" },
      ],
      samplecnt: 10,
      dataCount: null,
      chartData: [],
      graphRowCnt: 0,
      LoadYn: false,
      chartConfig: null,
      chartLayout: null, // s-v chart layout
      dualAxisChartLayout: null, // anal1/anal2 chart layout
      chartRange: [],
      chartRangeList: [],
    };
  },
  watch: {
    projectid() {
      this.getStructureList();
      this.getSensorTypeList();
    },
    "structure.selectedIdList": function () {
      this.getDeviceList();
      this.getSensorTypeList();
    },
    "structure.input": function () {
      this.changedStructureName();
    },
    "device.selectedIdList": function () {
      this.getSensorTypeList();
    },
    "device.input": function () {
      this.changedDeviceName();
    },
  },
  created() {
    this.getProjectList();
    this.stdate = moment().subtract(6, "days").format("YYYY-MM-DD");
    this.eddate = moment().format("YYYY-MM-DD");
  },
  beforeMount() {},
  mounted() {
    this.getCenterBus.$on("resizeEvent", () => this.resizeEvent());
    this.getDefaultCodes();
    this.getSensorChartConfig();
  },
  destroyed() {
    this.getCenterBus.$off("resizeEvent");
  },
  methods: {
    ...mapMutations(["setAlertTitle"]),
    isGNSS: utils.isGNSS,
    isDynamicSensor: utils.isDynamicSensor,
    resizeEvent() {},
    getDefaultCodes() {
      var reqBody = {
        codegrp: "sensortype",
      };
      this.$http
        .post("/comn/code", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let codes = reqBody.codegrp.split(",");
            for (let code of codes) {
              res.data[code].forEach((el) => {
                this.sensortype.codes.push({
                  value: el.cd,
                  text: el.nm,
                });
              });
            }
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProjectList() {
      let reqBody = {
        dbtype: "influxdb",
      };

      this.$http
        .post("/stat/getProjectList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [];

            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname,
                dbtype: data[i].storage,
              });
            }

            this.projectOptions = options;
            this.projectid = options[0].value;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStructureList() {
      this.structure.selectedIdList = [];
      this.structure.selectedTextList = [];

      var reqBody = {
        projectid: this.projectid,
      };

      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [];
            for (let i = 0; i < data.length; i++) {
              if (data[i].projectid === this.projectid) {
                options.push({
                  value: data[i].stid,
                  text: data[i].stname,
                  isChecked: false,
                });

                // this.structure.selectedIdList.push(data[i].stid);
                // this.structure.selectedTextList.push(data[i].stname);
              } else {
                continue;
              }
            }

            this.structure.isAllChecked = false;
            this.structure.options = options;
            this.structure.filteredOptions = options;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getDeviceList() {
      this.device.selectedIdList = [];
      this.device.selectedTextList = [];

      if (this.structure.selectedIdList.length === 0) {
        this.device.options = [];
        this.device.filteredOptions = [];
        return;
      }

      this.device.selectedIdList = [];

      let reqBody = {
        projectid: this.projectid,
        stidList: this.structure.selectedIdList,
      };

      this.$http
        .post("/device/getDeviceList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let devicelist = res.data.data.deviceList;
            let rowData = [];
            for (let i = 0; i < devicelist.length; i++) {
              rowData.push({
                value: devicelist[i].deviceid,
                text: devicelist[i].devicename,
                isChecked: true,
              });

              this.device.selectedIdList.push(devicelist[i].deviceid);
              this.device.selectedTextList.push(devicelist[i].devicename);
            }

            this.device.isAllChecked = true;
            this.device.options = rowData;
            this.device.filteredOptions = rowData;
          } else {
            this.setAlertTitle("디바이스 목록 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    makeTag() {
      let strings = [
        this.devicetype,
        this.deviceid,
        this.channel === 0 ? this.channel : this.channel - 1,
        this.datatype,
      ];
      return strings.join("_");
    },
    getChartData() {
      let dbtype = this.projectOptions.find(
        (option) => option.value === this.projectid
      ).dbtype;

      if (dbtype != "influxdb") {
        this.setAlertTitle();
        this.$bvModal
          .msgBoxOk(
            "프로젝트 설정에서 InfluxDB로 변경 후 조회가 가능합니다.",
            this.getAlertOptions
          )
          .catch((err) => {
            console.error(err);
          });
        return;
      }

      if (isNaN(this.samplecnt)) {
        this.setAlertTitle();
        this.$bvModal
          .msgBoxOk(
            "Sample Count는 숫자만 입력 가능합니다.",
            this.getAlertOptions
          )
          .catch((err) => {
            console.error(err);
          });
        return;
      }

      let selectedDeviceIdList = JSON.parse(
        JSON.stringify(this.device.selectedIdList)
      );
      selectedDeviceIdList.sort();

      let reqBody = {
        deviceIdList: selectedDeviceIdList,
        sensortype: this.sensortype.selectedIdList,
        datatype: this.datatype.selectedIdList,
        periodtype: this.periodtype,
        stdate: this.stdate,
        eddate: this.eddate,
        samplecnt: this.samplecnt,
      };

      this.LoadYn = true;

      this.$http
        .post("/sensor/getMeasurementDataList", reqBody, {
          timeout: 600 * 1000,
        })
        .then((res) => {
          console.log("res ==> ", res);
          if (res.data.resultyn === "Y") {
            this.initChartGraph();
            this.chartData = res.data.data.data;
            this.chartRange = res.data.data.chartRange;
            this.chartRangeList = res.data.data.chartRangeList;

            this.chartData.forEach((data) => {
              let isRawe = this.datatype.selectedIdList.includes("rawe");
              data.isRawe = isRawe;
              data.chartTitle =
                data.sensoralias +
                (utils.isDynamicSensor(data.devicetype)
                  ? isRawe
                    ? " RAWE"
                    : " ANAL1/ANAL2"
                  : " S-V");
            });

            this.graphRowCnt = this.chartData.length;

            this.$nextTick(() => {
              this.redrawChart();
              this.LoadYn = false;
            });
          } else {
            throw new Error(res.data.errormsg);
          }
        })
        .catch((err) => {
          console.error(err);
          this.LoadYn = false;
          let title = "데이터 조회 실패";
          let errorMessage = "관리자에게 문의하세요.";
          if (err.message === "No data") {
            errorMessage = "No data";
          }
          this.setAlertTitle(title);
          this.$bvModal
            .msgBoxOk(errorMessage, this.getAlertOptions)
            .catch((err) => {
              console.error(err);
            });
        });
    },
    getSensorChartConfig() {
      var reqBody = {
        settingtype: "AS",
      };
      this.$http
        .post("/sensor/getSensorChartConfig", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let config = res.data.data;
            this.chartConfig = config;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    initChartGraph() {
      for (let i = 0; i < this.chartData.length; i++) {
        if (utils.isDynamicSensor(this.chartData[i].devicetype)) {
          Plotly.purge("analChart" + (i + 1));
        } else {
          Plotly.purge("svChart" + (i + 1));
        }
      }
      this.isGnss = false;
    },
    redrawChart() {
      try {
        for (let i = 0; i < this.chartData.length; i++) {
          let chartid = null;
          if (utils.isDynamicSensor(this.chartData[i].devicetype)) {
            chartid = "analChart" + (i + 1);
            if (this.chartData[i].isRawe) {
              // SyncGW
              this.drawTimeLineChart(
                chartid,
                {
                  x: this.chartData[i].time,
                  y: this.chartData[i].rawe,
                  name1: "RAWE",
                  title1: "RAWE",
                },
                {
                  y: {
                    min: this.chartConfig.svstsv,
                    max: this.chartConfig.svedsv,
                  },
                }
              );
            } else {
              this.chartData[i].time = this.chartData[i].time.map((time) => {
                return moment(time).format("YYYY-MM-DD HH:mm:ss");
              });

              this.drawDualAxisTimeLineChart(
                chartid,
                {
                  x: this.chartData[i].time,
                  y1: this.chartData[i].anal1,
                  name1: "anal1",
                  title1: "ANAL_1(ma.u)",
                  y2: this.chartData[i].anal2,
                  name2: "anal2",
                  title2: "ANAL_2(ma.u)",
                },
                {
                  y: {
                    min: this.chartConfig.analstanal1,
                    max: this.chartConfig.analedanal1,
                  },
                  y2: {
                    min: this.chartConfig.analstanal2,
                    max: this.chartConfig.analedanal2,
                  },
                },
                false
              );
            }
          } else if (utils.isStaticSensor(this.chartData[i].devicetype)) {
            chartid = "svChart" + (i + 1);

            this.drawTimeLineChart(
              chartid,
              {
                x: this.chartData[i].time,
                y: this.chartData[i].sv,
                name: "S-V",
                title: "S-V(a.u)",
              },
              {
                y: {
                  min: this.chartConfig.svstsv,
                  max: this.chartConfig.svedsv,
                },
              }
            );
          }
        }
      } catch (err) {
        this.LoadYn = false;
        console.error(err);
      }
    },
    drawTimeLineChart(id, param, range) {
      const { dtick, dtick2, yAxisMin, yAxisMax, yAxisMin2, yAxisMax2 } =
        utils.getChartRangeValues(this.chartRangeList, this.chartRange, param);

      let data = [];
      data.push({
        x: param.x,
        y: param.y,
        type: "scatter",
        mode: "lines",
        line: { width: 1 },
        name: "",
      });
      this.chartLayout = chartUtil.setTimeLayout(id, {
        margin: {
          l: 80,
          r: 50,
          t: 40,
          b: 70,
          pad: 10,
        },
        annotation: param.annotation,
        showlegend: false,
      });
      this.chartLayout.xaxis = {
        nticks: 10,
        color: "#b4b7bd",
      };
      this.chartLayout.yaxis.dtick = dtick;
      this.chartLayout.yaxis.range = [yAxisMin, yAxisMax];
      this.chartLayout.height = 302;
      this.chartLayout.autosize = true;
      Plotly.newPlot(id, data, this.chartLayout, { responsive: true });
    },
    drawDualAxisTimeLineChart(id, param, range, isTempChart) {
      const { dtick, dtick2, yAxisMin, yAxisMax, yAxisMin2, yAxisMax2 } =
        utils.getChartRangeValues(this.chartRangeList, this.chartRange, param);

      var Data = [
        {
          x: param.x,
          y: param.y1,
          name: param.name1,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
        {
          x: param.x,
          y: param.y2,
          name: param.name2,
          type: "scatter",
          mode: "lines",
          yaxis: "y2",
          line: { width: 1 },
        },
      ];

      if (param.hasOwnProperty("y3")) {
        Data.push({
          x: param.x,
          y: param.y3,
          name: param.name3,
          type: "scatter",
          mode: "lines",
          yaxis: "y2",
          line: { width: 1 },
        });
      }

      if (isTempChart) {
        Data[0].line.color = "#ff7f0e";
        Data[1].line.color = "#1f77b4";
      }

      // anal1, anal2 중에 선택된 항목의 그래프만 표시
      var tmpLayout = document.getElementById(id);
      this.dualAxisChartLayout = {
        title: {},
        xaxis: {
          zeroline: false,
          color: "#b4b7bd",
          tickformat: "%Y-%m-%d %H:%M:%S",
          tickmode: "auto",
          nticks: param.x.length > 4 ? 4 : param.x.length,
        },
        yaxis: {
          title: {
            text: param.title1,
            font: {
              family: "Noto Sans KR",
              size: 17,
              weight: "normal",
            },
          },
          zeroline: false,
          color: "#b4b7bd",
          nticks: param.y1.length > 4 ? 4 : param.y1.length,
          dtick: dtick,
          range: [yAxisMin, yAxisMax],
        },
        yaxis2: {
          title: {
            text: param.title2,
            font: {
              family: "Noto Sans KR",
              size: 17,
              weight: "normal",
            },
          },
          zeroline: false,
          color: "#b4b7bd",
          overlaying: "y",
          side: "right",
          nticks: param.y2.length > 4 ? 4 : param.y2.length,
          dtick: dtick2,
          range: [yAxisMin2, yAxisMax2],
        },
        paper_bgcolor: "#283046",
        plot_bgcolor: "#283046",
        width: Math.floor(tmpLayout.clientWidth - 1),
        height: 302,
        showlegend: true,
        legend: {
          orientation: "h",
          x: 0.45,
          y: -0.15,
          font: {
            color: "#b4b7bd",
          },
        },
        margin: {
          l: 80,
          r: 80,
          t: 70,
          b: 30,
          pad: 0,
        },
        annotations: [],
      };

      if (param.hasOwnProperty("y3")) {
        this.dualAxisChartLayout.yaxis3 = {
          title: {
            text: param.title3,
            font: {
              family: "Noto Sans KR",
              size: 17,
              weight: "normal",
            },
          },
          zeroline: false,
          color: "#b4b7bd",
          overlaying: "y",
          side: "right",
          tickmode: "auto",
          nticks: param.y3.length > 4 ? 4 : param.y3.length,
        };
      }

      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          this.dualAxisChartLayout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          this.dualAxisChartLayout.yaxis.range = [range.y.min, range.y.max];
        }
        if (
          utils.chkNull(range.y2) !== null &&
          (range.y2.min !== 0 || range.y2.max !== 0)
        ) {
          this.dualAxisChartLayout.yaxis2.range = [range.y2.min, range.y2.max];
        }
        if (
          utils.chkNull(range.y3) !== null &&
          (range.y3.min !== 0 || range.y3.max !== 0)
        ) {
          this.dualAxisChartLayout.yaxis3.range = [range.y3.min, range.y3.max];
        }
      }
      Plotly.newPlot(id, Data, this.dualAxisChartLayout, {
        displaylogo: false,
      });
    },
    drawMultipleTimeLineChart(id, param, range) {
      let data = [];
      let keys = Object.keys(param.data);
      keys.forEach((key) => {
        if (key !== "tag" && key !== "time") {
          data.push({
            x: param.data.time,
            y: param.data[key],
            type: "scatter",
            mode: "lines",
            line: { width: 1 },
            name: this.typeRef[key],
          });
        }
        if (key === "count") {
          data[data.length - 1].visible = "legendonly";
        }
      });
      let layout = chartUtil.setTimeLayout(id, {
        margin: {
          l: 80,
          r: 50,
          t: 40,
          b: 50,
          pad: 10,
        },
        legend: {
          orientation: "h",
          x: 0.4,
          y: -0.15,
          font: {
            color: "#e2e2e2",
          },
        },
        annotation: param.annotation,
        showlegend: true,
      });
      layout.width = null;
      layout.height = null;
      layout.autosize = true;
      Plotly.newPlot(id, data, layout, { responsive: true });
    },
    changeDropdownCheckBox(e, idx) {
      let item = e.options[idx];
      if (e == this.datatype) {
        // 데이터 타입은 검색 기능이 없음
        if (e.options[idx].isChecked) {
          this.handleGroupDeselection(this.datatype, item.group);
          e.selectedIdList.push(e.options[idx].value);
          e.selectedTextList.push(e.options[idx].text);
        } else {
          let findedIdx = e.selectedIdList.indexOf(e.options[idx].value);
          if (findedIdx > -1) {
            e.selectedIdList.splice(findedIdx, 1);
            e.selectedTextList.splice(findedIdx, 1);
          }
        }
      } else {
        // 데이터 타입을 제외한 나머지
        let actualIndex = e.options.findIndex(
          (o) => o.text === e.filteredOptions[idx].text
        );

        if (e.options[actualIndex].isChecked) {
          e.selectedIdList.push(e.options[actualIndex].value);
          if (e !== this.sensortype) {
            e.selectedTextList.push(e.options[actualIndex].text);
          } else {
            e.selectedTextList.push(
              this.sensortype.codes.find(
                (code) => code.value === e.options[actualIndex].value
              ).text
            );
          }
        } else {
          let findedIdx = e.selectedIdList.indexOf(
            e.options[actualIndex].value
          );
          if (findedIdx > -1) {
            e.selectedIdList.splice(findedIdx, 1);
            e.selectedTextList.splice(findedIdx, 1);
          }
        }
      }

      // 모든 항목이 체크되어있으면 전체에 체크
      if (e.options.filter((o) => o.isChecked).length === e.options.length) {
        e.isAllChecked = true;
      } else {
        e.isAllChecked = false;
      }
    },
    handleGroupDeselection(datatype, group) {
      datatype.options.forEach((option) => {
        if (option.group !== group && option.isChecked) {
          option.isChecked = false;
          let idx = datatype.selectedIdList.indexOf(option.value);
          if (idx > -1) {
            datatype.selectedIdList.splice(idx, 1);
            datatype.selectedTextList.splice(idx, 1);
          }
        }
      });
    },
    changeAllCheckBox(e) {
      e.selectedIdList = [];
      e.selectedTextList = [];

      if (e.isAllChecked) {
        e.options.forEach((item) => {
          item.isChecked = true;
          e.selectedIdList.push(item.value);
          e.selectedTextList.push(item.text);
        });
      } else {
        e.options.forEach((item) => {
          item.isChecked = false;
        });
      }
    },
    downloadExcelFile() {
      this.LoadYn = true;

      let promises = [];

      let projectName = this.projectOptions.find(
        (option) => option.value === this.projectid
      ).text;

      let imageFileList = [];

      for (let i = 0; i < this.chartData.length; i++) {
        let chartDiv;
        if (utils.isDynamicSensor(this.chartData[i].devicetype)) {
          chartDiv = document.getElementById("analChart" + (i + 1));

          if (this.chartData[i].isRawe) {
            this.chartLayout.title = {
              text: this.chartData[i].sensoralias,
              font: {
                color: "#000",
                size: 20,
              },
            };
            this.chartLayout.plot_bgcolor = "#fff";
            this.chartLayout.paper_bgcolor = "#fff";
            this.chartLayout.xaxis.color = "#000";
            this.chartLayout.yaxis.color = "#000";
            this.chartLayout.legend = {
              font: {
                color: "#000",
              },
            };

            Plotly.relayout(chartDiv, this.chartLayout);
          } else {
            this.dualAxisChartLayout.title = {
              text:
                this.chartData[i].sensoralias +
                "(" +
                this.chartData[i].deviceId +
                ")",
              font: {
                color: "#000",
                size: 20,
              },
            };
            this.dualAxisChartLayout.plot_bgcolor = "#fff";
            this.dualAxisChartLayout.paper_bgcolor = "#fff";
            this.dualAxisChartLayout.xaxis.color = "#000";
            this.dualAxisChartLayout.yaxis.color = "#000";
            this.dualAxisChartLayout.yaxis2.color = "#000";
            this.dualAxisChartLayout.legend.font.color = "#000";

            Plotly.relayout(chartDiv, this.dualAxisChartLayout);
          }
        } else {
          chartDiv = document.getElementById("svChart" + (i + 1));

          this.chartLayout.title = {
            text: this.chartData[i].sensoralias,
            font: {
              color: "#000",
              size: 20,
            },
          };
          this.chartLayout.plot_bgcolor = "#fff";
          this.chartLayout.paper_bgcolor = "#fff";
          this.chartLayout.xaxis.color = "#000";
          this.chartLayout.yaxis.color = "#000";
          this.chartLayout.legend = {
            font: {
              color: "#000",
            },
          };

          console.log(this.chartLayout);
          Plotly.relayout(chartDiv, this.chartLayout);
        }

        if (chartDiv) {
          let promise = Plotly.toImage(chartDiv, {
            format: "jpeg",
          }).then((url) => {
            return new Promise((resolve) => {
              let imageData = url.split(",")[1];

              let blobData = atob(imageData);
              let array = [];
              for (let i = 0; i < blobData.length; i++) {
                array.push(blobData.charCodeAt(i));
              }
              let imageBlob = new Blob([new Uint8Array(array)], {
                type: "image/jpeg",
              });
              imageFileList.push(imageBlob);

              resolve();
            });
          });
          promises.push(promise);
        }
      }

      Promise.all(promises).then(() => {
        for (let i = 0; i < this.chartData.length; i++) {
          let chartDiv;
          if (utils.isDynamicSensor(this.chartData[i].devicetype)) {
            chartDiv = document.getElementById("analChart" + (i + 1));
            if (this.chartData[i].isRawe) {
              resetChartLayout(this.chartLayout);
              Plotly.relayout(chartDiv, this.chartLayout);
            } else {
              resetDualAxisChartLayout(this.dualAxisChartLayout);
              Plotly.relayout(chartDiv, this.dualAxisChartLayout);
            }
          } else {
            chartDiv = document.getElementById("svChart" + (i + 1));
            resetChartLayout(this.chartLayout);
            Plotly.relayout(chartDiv, this.chartLayout);
          }
        }

        let formData = new FormData();
        formData.append("projectName", projectName);
        formData.append("stdate", this.stdate);
        formData.append("eddate", this.eddate);
        formData.append("structureNameList", this.structure.selectedTextList);
        formData.append("deviceNameList", this.device.selectedTextList);
        for (let i = 0; i < imageFileList.length; i++) {
          formData.append("imageFileList", imageFileList[i]);
        }

        this.$http
          .post("/sensor/createMeasurementPdf", formData, {
            headers: { "Content-Type": "multipart/form-data" },
            responseType: "blob",
            timeout: 60000 * 30,
          })
          .then((res) => {
            this.LoadYn = false;
            const fileName = "계측 데이터.xlsx";

            // Blob 데이터로부터 URL 생성
            const url = window.URL.createObjectURL(new Blob([res.data]));

            // a 태그를 생성하여 프로그래밍 방식으로 클릭 이벤트를 발생시킴
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName); // 다운로드 파일 이름 설정
            document.body.appendChild(link);
            link.click();

            // URL 및 a 태그 제거
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          })
          .catch((err) => {
            this.LoadYn = false;
            console.error(err);
          });

        this.LoadYn = false;

        function resetDualAxisChartLayout(dualAxisChartLayout) {
          dualAxisChartLayout.title.text = "";
          dualAxisChartLayout.title.automargin = false;
          dualAxisChartLayout.title.font = {};
          dualAxisChartLayout.title.font.color = "#b4b7bd";
          dualAxisChartLayout.plot_bgcolor = "#283046";
          dualAxisChartLayout.paper_bgcolor = "#283046";
          dualAxisChartLayout.xaxis.color = "#b4b7bd";
          dualAxisChartLayout.yaxis.color = "#b4b7bd";
          dualAxisChartLayout.yaxis2.color = "#b4b7bd";
          dualAxisChartLayout.legend.font.color = "#b4b7bd";
        }

        function resetChartLayout(chartLayout) {
          chartLayout.title = {};
          chartLayout.title.font = {};
          chartLayout.title.font.color = "#b4b7bd";
          chartLayout.plot_bgcolor = "#283046";
          chartLayout.paper_bgcolor = "#283046";
          chartLayout.xaxis.color = "#b4b7bd";
          chartLayout.yaxis.color = "#b4b7bd";
          chartLayout.legend = {
            font: {
              color: "#b4b7bd",
            },
          };
        }
      });
    },
    getSensorTypeList() {
      this.sensortype.selectedIdList = [];
      this.sensortype.selectedTextList = [];

      var reqBody = {
        projectid: this.projectid,
        structureIdList: this.structure.selectedIdList,
        deviceIdList: this.device.selectedIdList,
      };
      this.$http
        .post("/sensor/getSensorTypeList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [];

            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].sensortype,
                text: this.sensortype.codes.find(
                  (code) => code.value === data[i].sensortype
                ).text,
                isChecked: true,
              });

              this.sensortype.selectedIdList.push(data[i].sensortype);
              this.sensortype.selectedTextList.push(
                this.sensortype.codes.find(
                  (code) => code.value === data[i].sensortype
                ).text
              );
            }

            this.sensortype.isAllChecked = true;
            this.sensortype.options = options;
            this.sensortype.filteredOptions = options;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    changedStructureName() {
      if (this.structure.input) {
        this.structure.filteredOptions = this.structure.options.filter(
          (item) => {
            return item.text.includes(this.structure.input);
          }
        );
      } else {
        this.structure.filteredOptions = this.structure.options;
      }
    },
    changedDeviceName() {
      if (this.device.input) {
        this.device.filteredOptions = this.device.options.filter((item) => {
          return item.text.includes(this.device.input);
        });
      } else {
        this.device.filteredOptions = this.device.options;
      }
    },
  },
};
</script>

<style lang="scss">
#measurementData {
  padding: 15px;
  .card {
    .card-body {
      padding: 0;
    }
  }
  & .searchBox {
    justify-content: space-between;
  }
  .searchBoxRow {
    width: 100%;
    display: flex;
    justify-content: start;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0px;
    }
  }
  .btnDiv {
    justify-content: flex-end;
  }
  .chartarea {
    height: calc(100% - 190px);
  }
  .graph {
    width: 100%;
    height: 100%;
  }
  .checkboxDropdown {
    button {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 200px;
    }
    .btn-secondary {
      color: #b4b7bd !important;
      background-color: transparent !important;
      border-color: #404656 !important;
    }

    .searchInputBox {
      border-radius: 0;
      border: none;
      border-bottom: 1px solid #404656;
      width: 100% !important;
      margin-bottom: 10px;
    }

    .checkboxDropdownForm {
      width: 100%;
      height: auto;

      div {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;

        .dropdownCheckbox {
          display: flex;
          flex-direction: row;
          width: 100%;
          position: relative;
          background: #283046;
          align-items: center;
          margin: 15px 0;

          .custom-control {
            position: absolute;
            width: 100%;
            z-index: 2;
          }

          .custom-control-input {
            width: 100% !important;
          }

          label {
            position: absolute;
            color: #b4b7bd;
            width: calc(100% - 25px);
            margin: 0 !important;
            padding-left: 25px;
            z-index: 1;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .dropdown-menu.show {
    display: block;
    background: #283046;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-top-style: none;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
    overflow-y: auto;
    max-height: 350px;
    min-width: 160px;
    width: auto;
  }
  .infoIcon {
    position: relative;
    float: right;
    margin-right: 10px;
    color: #b4b7bd;
    .tooltiptext {
      width: 300px;
      padding: 10px;
      visibility: hidden;
      height: fit-content;
      background-color: #161d31;
      color: #fff;
      text-align: center;
      border-radius: 6px;
      white-space: nowrap;
      position: absolute;
      z-index: 1;
    }

    .tooltip-bottom {
      top: 150%;
      left: -150px;
    }

    .tooltip-bottom::after {
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
    }
  }
  .infoIcon:hover {
    .tooltiptext {
      visibility: visible;

      table {
        width: 100%;
        table-layout: fixed;
        font-size: 13px;

        th {
          font-weight: normal;
          background-color: #6b6776;
          border-bottom: 1px solid rgb(93, 93, 93);
        }

        td {
          font-weight: normal;
          border-bottom: 1px solid rgb(93, 93, 93);
        }
      }
    }
  }
  .searchBtn {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/MeasurementData.vue